import './index.scss';
import React from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import DocSelect from './doc_select';
import DocView from './doc_view';
const DocumentsView = ({ state }) => {
    const { id: documentComparisonId } = useParams();
    return (React.createElement("div", { className: 'documents-panel' },
        React.createElement("div", { className: 'comparison-view-header' },
            React.createElement("div", { className: 'page-title' }, "Compare Documents"),
            React.createElement("div", { className: 'nav-toggle' },
                React.createElement("div", { className: 'toggle grid' },
                    React.createElement(Link, { to: `/compare/${documentComparisonId}` },
                        React.createElement("i", { className: 'fas fa-table fa-fw' }))),
                React.createElement("div", { className: 'toggle file' },
                    React.createElement("i", { className: 'fas fa-file fa-fw' })))),
        React.createElement("div", { className: 'comparison-documents' },
            React.createElement("div", { className: 'document-panel-compare' },
                React.createElement(DocSelect, { state: state, setDocument: state.switchAnchorDoc, document: state.anchorDoc, icon: 'fas fa-star' }),
                React.createElement(DocView, { activeClauseIds: state.activeClauseIds, areComparisonDocumentsLoading: state.areComparisonDocumentsLoading, document: state.anchorDoc, setDocHasRendered: state.setAnchorHasRendered, type: 'anchor' })),
            React.createElement("div", { className: 'document-panel-compare' },
                React.createElement(DocSelect, { state: state, setDocument: state.switchComparatorDoc, document: state.comparatorDoc, icon: 'fas fa-file' }),
                React.createElement(DocView, { activeClauseIds: state.activeClauseIds, areComparisonDocumentsLoading: state.areComparisonDocumentsLoading, document: state.comparatorDoc, setDocHasRendered: state.setComparatorHasRendered, type: 'comparator' })))));
};
export default DocumentsView;
